import { render } from "./topic_set_by.vue?vue&type=template&id=1224346e&ts=true"
import script from "./topic_set_by.vue?vue&type=script&lang=ts"
export * from "./topic_set_by.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/thelounge/thelounge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__